import * as React from 'react';

import { cn } from '../lib/utils';
import { useFieldControlAria } from './field-aria';

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<'textarea'>
>(
  (
    {
      className,
      'aria-invalid': ariaInvalid,
      'aria-describedby': ariaDescribedBy,
      ...props
    },
    ref
  ) => {
  // WCAG 3.3.1 — inherit aria-invalid/aria-describedby from an enclosing
  // <Field>'s registered description/error elements (explicit aria wins).
  const fieldAria = useFieldControlAria({ ariaInvalid, ariaDescribedBy });
  return (
    <textarea
      aria-invalid={fieldAria['aria-invalid']}
      aria-describedby={fieldAria['aria-describedby']}
      className={cn(
        'flex min-h-[80px] w-full rounded-xl border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      ref={ref}
      {...props}
    />
  );
  }
);
Textarea.displayName = 'Textarea';

export { Textarea };
